




















import Vue, { PropOptions } from 'vue';

export interface TableHeader {
    label: string;
    center?: boolean;
}

export default Vue.extend({
    name: 'Table',
    props: {
        headers: {
            type: Array,
            required: true,
        } as PropOptions<TableHeader[]>,
    },
});
